module.exports = __webpack_public_path__ + "chat-icon.e0d2b748.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat-icon.svg
// module id = 47
// module chunks = 0